/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { GET_APPLICATION, GET_WP_APPLICATION } from '../../api/graphql';
import { useApplication } from '../provider';
import { FormatAppService } from './formatApp.plugin';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface ISubmittedAppMethods extends IPluginMethodMap {
  getApplicationDetail(args: any): Promise<any>;
}

export class SubmittedAppService implements IAgentPlugin {
  readonly methods: ISubmittedAppMethods;

  constructor() {
    this.methods = {
      getApplicationDetail: this.getApplicationDetail.bind(this),
    };
  }

  private async getApplicationDetail(args: any) {
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    const { applicationNo } = useApplication();
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`getUserListsProps service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(GET_APPLICATION, {
          applicationNo,
        });
        if (res?.data?.getApplication) {
          console.log(`table data`, res);
        
          return new FormatAppService().formatApp(res?.data?.getApplication);
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      throw err;
    }
  }
}
